module.exports = __webpack_public_path__ + "99ed34930a8d49c61b1533414a25d459.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/ALLEYESONUS_HEAD.jpg
// module id = 472
// module chunks = 0